<div (click)="toggleColumnSelectionMode($event, column.field)" class="column-move-selector">
  @if (!columnSelectionMode(column.field)) {
    <span title="{{column.header}}">{{column.header}}</span>
  }
  @if (columnSelectionMode(column.field)) {
    <div>
      <forge-autocomplete #autocomplete filterFocusFirst="true" [filter]="autocompleteFilter" debounce="0" (forge-autocomplete-change)="onSelectedItemChange($event)">
        <forge-text-field>
          <input #autocompleteInput type="text" tabindex="0" placeholder="Move column" telemetry="Move column" aria-label="move column" (blur)="close()">
        </forge-text-field>
      </forge-autocomplete>
    </div>
  }
</div>
